/**
 * Session Movement resource
 *
 * @name SessionMovement
 * @class
 * @augments TmrResource
 */
export const factory = [
  'SessionMovement',
  /*@ngInject*/ (TmrApi, TmrResource, Session, Parcel) => {
    let actions = {
      createSessionMovement: {
        url: TmrApi.endpoint('SessionMovement.create'),
        method: 'POST',
        isArray: false,
      },
    }

    let referencedProperties = [
      { property: 'parcel', resource: Parcel },
      { property: 'session', resource: Session },
    ]

    let defaultValues = () => ({
      attributes: {},
    })

    let SessionMovement = TmrResource(
      'SessionMovement',
      actions,
      referencedProperties,
      defaultValues
    )

    function getValue(code) {
      if (typeof code !== 'string') {
        throw new Error(
          'SessionMovement.getValue(code) action requires a configuration key (code)'
        )
      }
      return TmrApi.get(
        'SessionMovement',
        { id: null },
        { params: { code } }
      ).then(res => (res.data.length ? res.data[0].value : null))
    }

    Object.assign(SessionMovement, { getValue })

    /**
     * Performs a transfer to zone movement
     *
     * @method sessionMovementTransferToZone#transfer
     * @param {string} sessionMovementType The session movement type
     * @param {session} session The Session
     * @param {destinationZone} destinationZone The destination zone
     */
    function transfer(sessionMovementType, session, destinationZone) {
      if (typeof session !== 'object') {
        throw new Error(
          'sessionMovementTransferToZone.transfer(sessionMovementType, session, destinationZone) action requires a Session'
        )
      }
      if (typeof destinationZone !== 'object') {
        throw new Error(
          'sessionMovementTransferToZone.transfer(sessionMovementType, session, destinationZone) action requires a destination Zone'
        )
      }
      return this.save({ sessionMovementType, session, destinationZone })
    }

    Object.assign(SessionMovement, { transfer })

    return SessionMovement
  },
]
